/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiPartner.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-partner";

export class AutogenModelEdiPartner<RowType extends ModelRow> extends Endpoint<RowType, RowEdiPartnerFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiPartner extends ModelRow<RowEdiPartnerFields> {
	constructor(values?: Partial<RowEdiPartnerFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiPartnerFields {
	alt_partner_id: string;
	company_id: string;
	id: string;
	next_batch: number;
	notes: string;
	partner_id: string;
	partner_name: string;
	version: string;
}

